import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Row, Col, Spinner } from "react-bootstrap";
import ApexCharts from "components/elements/charts/ApexCharts";
import quizLogo from "assets/images/quizLogo.png";
import Questions from "./Questions";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import quizFailWalpaper from "../../../../../assets/images/svg/quiz-fail-walpaper.svg";
import congratulations from "../../../../../assets/images/svg/congratulations.svg";
import { CircularProgress } from "@mui/material";

const QuizResult = ({
  score,
  quiz,
  quizStatus,
  selectedAnswers,
  passPercentage,
  correctAnswers,
  userScore,
  totalScore,
  status,
  retryQuiz,
  loading,
  percentageScore,
  correctQuestionsCount,
  totalQuestionsCount
}) => {
  const [isReviewMode, setIsReviewMode] = useState(false);
  const navigate = useNavigate();
  const [cookies, setCookies] = useCookies();
  
  // Safe percentage calculation - handles NaN cases and prioritizes accuracy
  const calculatePercentage = () => {
    // If backend provided a non-zero percentage, use it
    if (typeof percentageScore === 'number' && !isNaN(percentageScore) && percentageScore > 0) {
      return percentageScore;
    }
    
    // Otherwise calculate from questions count (if available) or score
    const correctCount = Number(correctQuestionsCount || userScore || score || 0);
    const totalCount = Number(totalQuestionsCount || totalScore || 1);
    
    if (totalCount <= 0) return 0;
    
    const percentage = (correctCount / totalCount) * 100;
    return Number.isFinite(percentage) ? percentage : 0;
  };
  
  const percentageValue = calculatePercentage();
  const QuizResultChartSeries = [Number(percentageValue.toFixed(0))];
  const chartColor = status ? "#38a169" : "#e53e3e";
  const backgroundColor = status ? "#d1f5ea" : "#fcdcdc";

  const QuizResultChartOptions = {
    colors: [chartColor],
    plotOptions: {
      radialBar: {
        hollow: {
          margin: -2,
          size: "50%",
          background: backgroundColor,
        },
        dataLabels: {
          name: { 
            show: true, 
            fontSize: "18px", 
            fontWeight: 600, 
            offsetY: 7,
            formatter: () => `${percentageValue.toFixed(0)}%`
          },
          value: { show: false },
        },
      },
    },
    labels: [status ? "Passed" : "Failed"],
  };

  useEffect(() => {
    setIsReviewMode(false);
  }, [quiz]);

  const handleClick = () => {
    navigate("/assessment-review");
  };

  const handleReviewQuestions = () => {
    setIsReviewMode(true);
  };

  const handleBackToQuiz = () => {
    setIsReviewMode(false);
  };

  const handleRetryQuiz = () => {
    retryQuiz("retry");
  };

  // if (loading) {
  //   return (
  //     // <div className="d-flex justify-content-center align-items-center w-100 h-100  ">
  //     <CircularProgress />
  //     // </div>
  //   );
  // }

  const teacherReviewAlert = (
    <div className="mt-4 w-75 mx-auto">
      {quiz?.teacherReviewed && !quiz?.redo ? (
        <div className="alert alert-success d-flex align-items-center justify-content-center py-2" style={{ borderRadius: "10px", border: "none", backgroundColor: "#e6f4ea", color: "#137333" }}>
          <i className="fe fe-check-circle me-2"></i>
          <span className="fw-medium">Course manager reviewed, and these are final marks.</span>
        </div>
      ) : quiz?.teacherReviewed && quiz?.redo ? (
        <div className="alert alert-info d-flex align-items-center justify-content-center py-2" style={{ borderRadius: "10px", border: "none", backgroundColor: "#e8f0fe", color: "#1967d2" }}>
          <i className="fe fe-info me-2"></i>
          <span className="fw-medium">Note: These marks are not final. Course manager review is pending (Redo maybe required).</span>
        </div>
      ) : (
        <div className="alert alert-info d-flex align-items-center justify-content-center py-2" style={{ borderRadius: "10px", border: "none", backgroundColor: "#e8f0fe", color: "#1967d2" }}>
          <i className="fe fe-info me-2"></i>
          <span className="fw-medium">Note: These marks are not final. Course manager review is pending (Redo maybe required).</span>
        </div>
      )}
    </div>
  );

  if (isReviewMode) {
    return (
      <>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div
              className="justify-content-between align-items-center d-flex p-2 px-15"
              style={{ backgroundColor: "#f1eef0" }}
            >
              <div className="text-center">
                {quizStatus === "finish" ? (
                  <h3 className="text-dark mb-0">
                    You have successfully completed the quiz!
                  </h3>
                ) : quizStatus === "timeout" ? (
                  <h3 className="text-dark mb-0">
                    Timeout! Your Quiz got submitted successfully!
                  </h3>
                ) : null}
              </div>

              <div className="d-flex justify-content-center">
                <div className="resultChart">
                  <ApexCharts
                    options={QuizResultChartOptions}
                    series={QuizResultChartSeries}
                    type="radialBar"
                    height={150}
                  />
                </div>
              </div>
              <div>
                <img
                  src={quizLogo}
                  alt="Quiz completion logo"
                  width={150}
                  height={150}
                />
              </div>
            </div>
          </Col>
        </Row>

        <div>
          <div className="d-flex justify-content-start my-4">
            <button className="btn btn-secondary" onClick={handleBackToQuiz}>
              Back
            </button>
          </div>

          <Card className="mb-4">
            <Card.Body className="card-body-scroll">
              <h4 className="mb-3">Review Questions</h4>
              <div className="mt-5">
                <Questions
                  questions={quiz.questions}
                  selectedAnswers={selectedAnswers}
                  isReview={isReviewMode}
                  correctAnswers={correctAnswers}
                  result={correctAnswers}
                />
              </div>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }

  if (status) {
    return (
      <Card>
        <Card.Body className="p-10 text-center">
          {quizStatus === "finish" ? (
            <h3
              className="text-dark mb-0"
              style={{
                color: "#288F58",
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "36px",
                lineHeight: "43.57px",
                letterSpacing: "2%",
                textAlign: "center",
              }}
            >
              Congratulations
            </h3>
          ) : quizStatus === "timeout" ? (
            <h3 className="text-dark mb-0">
              Timeout! Your Quiz got submitted successfully!
            </h3>
          ) : null}
          <div className="mt-5">
            <img src={congratulations} alt="congratulation image" />
          </div>
          <div className="d-flex justify-content-center">
            <div className="resultChart">
              <ApexCharts
                options={QuizResultChartOptions}
                series={QuizResultChartSeries}
                type="radialBar"
                height={150}
              />
            </div>
          </div>
          <div className="d-flex flex-column align-items-center mb-3">
            <h5 className="mb-1">
              You got {correctQuestionsCount !== "" && correctQuestionsCount !== undefined ? correctQuestionsCount : userScore} out of {totalQuestionsCount !== "" && totalQuestionsCount !== undefined ? totalQuestionsCount : totalScore} right
            </h5>
            <p className="text-muted small mb-0">
              Total Score: {score} / {totalScore}
            </p>
          </div>
          <div>
            <p
              style={{
                color: "#288F58",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: "24px",
                lineHeight: "22.39px",
                letterSpacing: "2%",
                textAlign: "center",
              }}
            >
              Great Work
            </p>
            <div className="d-flex justify-content-center">
              <p
                className="w-50 text-center"
                style={{
                  color: "#00000080",
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "26px",
                  letterSpacing: "2%",
                  textAlign: "center",
                }}
              >
                You're doing really well! Just a little more effort, and you'll
                reach perfection!
              </p>
            </div>
          </div>

          {teacherReviewAlert}

          <div className="mt-4 d-flex justify-content-center">
            <button
              className="btn btn-primary me-3"
              onClick={handleReviewQuestions}
            >
              Review Answers
            </button>

            {/* {cookies.roleId === "courseParticipant" && (
              <button
                className="btn btn-outline-primary me-3"
                style={{
                  color: "var(--bs-primary)",
                  borderColor: "var(--bs-primary)",
                  borderWidth: "2px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "var(--bs-primary)";
                  e.target.style.borderColor = "var(--bs-primary)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "var(--bs-primary)";
                  e.target.style.borderColor = "var(--bs-primary)";
                }}
                onClick={handleClick}
              >
                Go to Assessment Review
              </button>
            )} */}
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <>
    {loading ? (
      <div></div>
    ) : quizStatus === "finish" ? (
      <Card>
        <Card.Body className="p-10 text-center">
          <div className="mb-4">
            <h2>Oops! You couldn't clear the quiz</h2>
          </div>
          <div>
            <img src={quizFailWalpaper} alt="quiz fail wallpaper" />
          </div>
          <div className="d-flex justify-content-center">
            <div className="resultChart">
              <ApexCharts
                options={QuizResultChartOptions}
                series={QuizResultChartSeries}
                type="radialBar"
                height={150}
              />
            </div>
          </div>
          <div className="d-flex flex-column align-items-center mb-3">
            <h5 className="mb-1">
              You got {correctQuestionsCount !== "" && correctQuestionsCount !== undefined ? correctQuestionsCount : userScore} out of {totalQuestionsCount !== "" && totalQuestionsCount !== undefined ? totalQuestionsCount : totalScore} right
            </h5>
            <p className="text-muted small mb-0">
              Total Score: {score} / {totalScore}
            </p>
          </div>
          <div>
            <p className="text-danger fw-bold fs-4 text-center">Poor Performance!</p>
            <div className="d-flex justify-content-center">
              <p className="w-50 text-center text-muted">
                Don't worry! Every attempt is a step toward improvement.
                Review your answers and try again—you've got this!
              </p>
            </div>
          </div>
          {status && teacherReviewAlert}

        </Card.Body>
      </Card>
    ) : quizStatus === "timeout" ? (
      <Card>
        <Card.Body className="p-10 text-center">
          <div className="mb-4">
            <h2>Oops! Time Out.</h2>
          </div>
          <div>
            <img src={quizFailWalpaper} alt="quiz fail wallpaper" />
          </div>
          <div className="d-flex justify-content-center">
            <div className="resultChart">
              <ApexCharts
                options={QuizResultChartOptions}
                series={QuizResultChartSeries}
                type="radialBar"
                height={150}
              />
            </div>
          </div>
          <p>
            You got {score} out of {totalScore}
          </p>
          <div>
            <p className="text-danger fw-bold fs-4 text-center">Time Out!</p>
            <div className="d-flex justify-content-center">
              <p className="w-50 text-center text-muted">
                Don't worry! Every attempt is a step toward improvement.
                Review your answers and try again—but be mindful of the time!
              </p>
            </div>
          </div>
          {status && teacherReviewAlert}

        </Card.Body>
      </Card>
    ) : null}
  </>
  
  );
};

export default QuizResult;
